import React from 'react'

const Reset = () => {
  return (
    <div>resets</div>
  )
}

export default Reset